// extracted by mini-css-extract-plugin
export default {"errorCont":"navBar_errorCont__CPxs0","savedLoading":"navBar_savedLoading__wJzJe","savedText":"navBar_savedText__v2dkk","back":"navBar_back__mIZuq"};